import styles from './FetchErrorNotification.module.css'

type FetchErrorNotificationProps = {
	url?: string
	status: number | string
	data?: unknown
}

const hasData = (data: unknown): boolean => {
	if (data === null || data === undefined) {
		return false
	}
	if (typeof data === 'string') {
		return data.trim().length > 0
	}
	return true
}

export const FetchErrorNotification = ({ status, url, data }: FetchErrorNotificationProps) => {
	let formattedData
	if (hasData(data)) {
		try {
			formattedData = JSON.stringify(data, undefined, 2)
		} catch {
			console.error("Couldn't format data: ", data)
		}
	}
	return (
		<div>
			<div className={styles.row}>Request failed, status: {status}</div>
			{!!url && (
				<div className={styles.row} title={url}>
					Url: {url}
				</div>
			)}
			{!!formattedData && (
				<div className={styles.row}>
					<pre data-test="fetch-error-data">{formattedData}</pre>
				</div>
			)}
		</div>
	)
}
